import styles from './ProgressBar.module.css';

/**
 * 🔒 The Progress Bar (piece 31; decision 3164): a native progress element, as
 * the drop zone's per-file progress is (decision 0070), so a screen reader
 * reads its value and its name. It measures a known count and never guesses one:
 * where nothing is known, the caller draws no bar at all.
 */
export interface ProgressBarProps {
  value: number;
  max: number;
  /** What is measured, read aloud: the bar names it, since it carries no text of its own. */
  label: string;
}

export const progressBarDocumentedStates = ['empty', 'part', 'full'] as const;

export function ProgressBar({ value, max, label }: ProgressBarProps) {
  const top = max > 0 ? max : 1;
  const held = Math.min(Math.max(value, 0), top);
  return <progress className={styles.bar} value={held} max={top} aria-label={label} data-progress-bar={`${held}/${top}`} />;
}
